import GoogleCloudIcon from "./all-icons/multiColorIcons/GoogleCloudIcon";
import NodeJsIcon from "./all-icons/multiColorIcons/NodeJsIcon";
import ReactJsIcon from "./all-icons/multiColorIcons/ReactJsIcon";
import AngularIcon from "./all-icons/multiColorIcons/AngularIcon";
import FlutterIcon from "./all-icons/multiColorIcons/FlutterIcon";
import AndroidStudioIcon from "./all-icons/multiColorIcons/AndroidStudioIcon";
import IosIcon from "./all-icons/multiColorIcons/IosIcon";
import AWSCloudIcon from "./all-icons/multiColorIcons/AWSCloudIcon";
import VueJsIcon from "./all-icons/multiColorIcons/VueJsIcon";
import MicrosoftAzureIcon from "./all-icons/multiColorIcons/MicrosoftAzureIcon";
import ConsumerPackageIcon from "./all-icons/ConsumerPackageIcon";
import CommunicationIcon from "./all-icons/CommunicationIcon";
import TravelIcon from "./all-icons/TravelIcon";
import ManufacturingIcon from "./all-icons/ManufacturingIcon";
import InformationIcon from "./all-icons/InformationIcon";
import MediaIcon from "./all-icons/MediaIcon";
import InsuranceIcon from "./all-icons/InsuranceIcon";
import TransformationIcon from "./all-icons/TransformationIcon";
import MySqlIcon from "./all-icons/MySqlIcon";
import PostGreSqlIcon from "./all-icons/PostGreSqlIcon";
import MongoDbIcon from "./all-icons/MongoDbIcon";
import DynamoDbIcon from "./all-icons/DynamoDbIcon";
import ElasticsSearchIcon from "./all-icons/ElasticsSearchIcon";
import AmplifyAwsIcon from "./all-icons/AmplifyAwsIcon";
import SqsAwsIcon from "./all-icons/SqsAwsIcon";
import CognitoAwsIcon from "./all-icons/CognitoAwsIcon";
import S3AwsIcon from "./all-icons/S3AwsIcon";
import Pm2Icon from "./all-icons/Pm2Icon";
import WebSocketIcon from "./all-icons/WebSocketIcon";
import NginxIcon from "./all-icons/NginxIcon";
import ApacheIcon from "./all-icons/ApacheIcon";
import SocketIoIcon from "./all-icons/SocketIoIcon";
import Route53Icon from "./all-icons/Route53Icon";
import LambdaIcon from "./all-icons/LambdaIcon";
import KafkaIcon from "./all-icons/KafkaIcon";
import BankIcon from "./all-icons/BankIcon";
import HealthCareIcon from "./all-icons/HealthCareIcon";
import LifeSciencesIcon from "./all-icons/LifeSciencesIcon";
import HighTechIcon from "./all-icons/HighTechIcon";
import RetailIcon from "./all-icons/RetailIcon";
import RightSideArrowIcon from "./all-icons/RightSideArrowIcon";
import DiscoverIcon from "./all-icons/DiscoverIcon";
import DesignIcon from "./all-icons/DesignIcon";
import BuildIcon from "./all-icons/BuildIcon";
import DeliverIcon from "./all-icons/DeliverIcon";
import EcomCustomeIcon from "./all-icons/EcomCustomeIcon";
import AppDevCustomeIcon from "./all-icons/AppDevCustomeIcon";
import AiCustomeIcon from "./all-icons/AiCustomeIcon";
import DevSearchCustomeIcon from "./all-icons/DevSearchCustomeIcon";
import UiUXCustomeIcon from "./all-icons/UiUXCustomeIcon";
import DigitalMarketingCustomeIcon from "./all-icons/DigitalMarketingCustomeIcon";
import WebDevCustomeIcon from "./all-icons/WebDevCustomeIcon";
import WhatsAppIcon from "./all-icons/WhatsAppIcon";
import CheckIcon from "./all-icons/CheckIcon";
import MonitorIcon from "./all-icons/MonitorIcon";
import ShieldIcon from "./all-icons/ShieldIcon";
import CustomGlobeIcon from "./all-icons/CustomGlobeIcon";
import StarIcon from "./all-icons/StarIcon";
import LightningIcon from "./all-icons/LightningIcon";
import GlobeTalentIcon from "./all-icons/GlobeTalentIcon";
import CostIcon from "./all-icons/CostIcon";
import DeliveryIcon from "./all-icons/DeliveryIcon";



interface IconProps {
    iconName: string;
    height: string;
    width: string;
    color: string;
    strockColor?: string;
    strokeWidth?: number;
}

export default function AllIconsComponent({ iconName, height, width, color, strockColor, strokeWidth }: IconProps) {
    return (
        <>
            {iconName === "webDevIcon" && <WebDevCustomeIcon height={height} width={width} color={color} />}
            {iconName === "digitalMarketingIcon" && <DigitalMarketingCustomeIcon height={height} width={width} color={color} />}
            {iconName === "uiuxIcon" && <UiUXCustomeIcon height={height} width={width} color={color} />}
            {iconName === "devSearchIcon" && <DevSearchCustomeIcon height={height} width={width} color={color} />}
            {iconName === "aiIcon" && <AiCustomeIcon height={height} width={width} color={color} />}
            {iconName === "ecomIcon" && <EcomCustomeIcon height={height} width={width} color={color} />}
            {iconName === "appDevIcon" && <AppDevCustomeIcon height={height} width={width} color={color} />}
            {iconName === "rightSideArrowIcon" && <RightSideArrowIcon height={height} width={width} color={color} />}

            {iconName === "bankIcon" && <BankIcon height={height} width={width} color={color} />}
            {iconName === "healthcareIcon" && <HealthCareIcon height={height} width={width} color={color} />}
            {iconName === "lifeSciencesIcon" && <LifeSciencesIcon height={height} width={width} color={color} />}
            {iconName === "highTechIcon" && <HighTechIcon height={height} width={width} color={color} />}
            {iconName === "retailIcon" && <RetailIcon height={height} width={width} color={color} />}
            {iconName === "consumerPackageIcon" && <ConsumerPackageIcon height={height} width={width} color={color} />}
            {iconName === "communicationIcon" && <CommunicationIcon height={height} width={width} color={color} />}
            {iconName === "travelIcon" && <TravelIcon height={height} width={width} color={color} />}
            {iconName === "manufacturingIcon" && <ManufacturingIcon height={height} width={width} color={color} />}
            {iconName === "informationIcon" && <InformationIcon height={height} width={width} color={color} />}
            {iconName === "mediaIcon" && <MediaIcon height={height} width={width} color={color} />}
            {iconName === "insuranceIcon" && <InsuranceIcon height={height} width={width} color={color} />}
            {iconName === "transformationIcon" && <TransformationIcon height={height} width={width} color={color} />}


            {/* MultiColor Icons ///////////////////////////////////////// */}
            {iconName === "nodeJsIcon" && <NodeJsIcon height={height} width={width} color={color} />}
            {iconName === "reactJsIcon" && <ReactJsIcon height={height} width={width} color={color} />}
            {iconName === "angularIcon" && <AngularIcon height={height} width={width} color={color} />}
            {iconName === "flutterIcon" && <FlutterIcon height={height} width={width} color={color} />}
            {iconName === "androidStudioIcon" && <AndroidStudioIcon height={height} width={width} color={color} />}
            {iconName === "iosIcon" && <IosIcon height={height} width={width} color={color} />}
            {iconName === "awsCloudIcon" && <AWSCloudIcon height={height} width={width} color={color} />}
            {iconName === "vueJsIcon" && <VueJsIcon height={height} width={width} color={color} />}
            {iconName === "microsoftAzureIcon" && <MicrosoftAzureIcon height={height} width={width} color={color} />}
            {iconName === "googleCloudIcon" && <GoogleCloudIcon height={height} width={width} color={color} />}



            {iconName === "mySqlIcon" && <MySqlIcon height={height} width={width} color={color} />}
            {iconName === "postGreSqlIcon" && <PostGreSqlIcon height={height} width={width} color={color} />}
            {iconName === "mongoDbIcon" && <MongoDbIcon height={height} width={width} color={color} />}
            {iconName === "dynamoDbIcon" && <DynamoDbIcon height={height} width={width} color={color} />}
            {iconName === "elasticsSearchIcon" && <ElasticsSearchIcon height={height} width={width} color={color} />}


            {iconName === "amplifyAwsIcon" && <AmplifyAwsIcon height={height} width={width} color={color} />}
            {iconName === "sqsAwsIcon" && <SqsAwsIcon height={height} width={width} color={color} />}
            {iconName === "cognitoAwsIcon" && <CognitoAwsIcon height={height} width={width} color={color} />}
            {iconName === "s3AwsIcon" && <S3AwsIcon height={height} width={width} color={color} />}
            {iconName === "kafkaIcon" && <KafkaIcon height={height} width={width} color={color} />}
            {iconName === "pm2Icon" && <Pm2Icon height={height} width={width} color={color} />}
            {iconName === "webSocketIcon" && <WebSocketIcon height={height} width={width} color={color} />}
            {iconName === "nginxIcon" && <NginxIcon height={height} width={width} color={color} />}
            {iconName === "apacheIcon" && <ApacheIcon height={height} width={width} color={color} />}
            {iconName === "socketIoIcon" && <SocketIoIcon height={height} width={width} color={color} />}
            {iconName === "route53Icon" && <Route53Icon height={height} width={width} color={color} />}
            {iconName === "lambdaIcon" && <LambdaIcon height={height} width={width} color={color} />}


            {iconName === "discoverIcon" && <DiscoverIcon height={height} width={width} color={color} />}
            {iconName === "designIcon" && <DesignIcon height={height} width={width} color={color} />}
            {iconName === "buildIcon" && <BuildIcon height={height} width={width} color={color} />}
            {iconName === "deliverIcon" && <DeliverIcon height={height} width={width} color={color} />}

            {iconName === "whatsAppIcon" && <WhatsAppIcon height={height} width={width} color={color} />}
            {iconName === "checkIcon" && <CheckIcon height={height} width={width} color={color} />}
            {iconName === "monitorIcon" && <MonitorIcon color={color} />}
            {iconName === "shieldIcon" && <ShieldIcon color={color} />}
            {iconName === "globeIcon" && <CustomGlobeIcon color={color} />}
            {iconName === "starIcon" && <StarIcon color={color} />}

            {iconName === "lightningIcon" && <LightningIcon color={color} />}
            {iconName === "globeTalentIcon" && <GlobeTalentIcon color={color} />}
            {iconName === "costIcon" && <CostIcon color={color} />}
            {iconName === "deliveryIcon" && <DeliveryIcon color={color} />}



        </>
    )
}
